// Custom cursor
const cur = document.getElementById('cur');
const curR = document.getElementById('curR');
if (cur && curR) {
  let mx = 0, my = 0, rx = 0, ry = 0;
  document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
  (function tick() {
    cur.style.left = mx + 'px'; cur.style.top = my + 'px';
    rx += (mx - rx) * .12; ry += (my - ry) * .12;
    curR.style.left = rx + 'px'; curR.style.top = ry + 'px';
    requestAnimationFrame(tick);
  })();
  document.querySelectorAll('a,button').forEach(el => {
    el.addEventListener('mouseenter', () => {
      cur.style.transform = 'translate(-50%,-50%) scale(2.2)';
      curR.style.borderColor = 'rgba(201,168,76,.6)';
    });
    el.addEventListener('mouseleave', () => {
      cur.style.transform = 'translate(-50%,-50%) scale(1)';
      curR.style.borderColor = 'rgba(255,255,255,.35)';
    });
  });
}

// Scroll reveal
const io = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
  });
}, { threshold: .08 });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

// Cart count update
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const btn = document.querySelector('.nav-btn');
      if (btn) btn.textContent = 'Cart (' + cart.item_count + ')';
    });
}
updateCartCount();

// Add to cart
document.querySelectorAll('.btn-add[data-variant-id]').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(() => {
      updateCartCount();
      btn.textContent = 'Added!';
      setTimeout(() => btn.textContent = 'Add to Cart', 2000);
    });
  });
});
